// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg fill=%27gray%27 height=%2720%27 viewBox=%270 0 24 24%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M14 7l-5 5 5 5V7z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg fill=%27gray%27 height=%2720%27 viewBox=%270 0 24 24%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M10 17l5-5-5-5v10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Wrapper Around Entire Component === */
.date-slider-row-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 1.5rem 0;
  padding: 1rem;
  border-radius: var(--radius);
  background-color: var(--clr-white);
  box-shadow: var(--shadow-1);
}

/* === Grid Container for 14 Dates in 2 Rows === */
.date-grid-new {
  display: grid;
  grid-template-columns: repeat(7, minmax(100px, 1fr));
  grid-template-rows: repeat(2, auto);
  gap: 0.75rem;
  flex-grow: 1;
  max-width: 100%;
}

/* === Individual Date Button === */
.date-grid-btn {
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  border-radius: 8px;
  border: 1px solid var(--clr-primary-4);
  background-color: var(--clr-grey-5);
  color: var(--clr-white);
  cursor: pointer;
  font-weight: 500;
  text-align: center;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: var(--shadow-xs);
  white-space: nowrap;
}

.date-grid-btn:hover {
  background-color: var(--clr-primary-1);
  border-color: var(--clr-primary-6);
  transform: translateY(-1px);
}

.date-grid-btn.selected {
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  border-color: var(--clr-primary-6);
  box-shadow: var(--shadow-1);
}

/* === Arrow Buttons (Prev/Next) === */
.slider-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--clr-white);
  border: 1px solid var(--clr-primary-5);
  border-radius: 50%;
  
  width: 2.25rem;
  height: 2.25rem;
  min-width: 2.25rem;
  min-height: 2.25rem;

  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px;

  padding: 0; /* Ensures icon stays centered */
  box-sizing: border-box;

  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.slider-arrow-btn:hover {
  transform: scale(1.05);
}


.slider-arrow-btn.left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.slider-arrow-btn.right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.slider-arrow-btn:hover {
  background-color: var(--clr-primary-10);
}

.slider-arrow-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* === Loading Spinner === */
.loading-spinner_v3 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  text-align: center;
  color: var(--clr-grey-6);
  font-size: 1rem;
  position: relative;
}

.loading-spinner_v3::before {
  content: "";
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.75rem;
  border: 3px solid var(--clr-grey-5);
  border-top-color: var(--clr-primary-7);
  border-radius: 50%;
  animation: spinLoader 0.8s linear infinite;
}

@keyframes spinLoader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* === Responsive Tweaks === */
@media (max-width: 1024px) {
  .date-grid-new {
    grid-template-columns: repeat(4, minmax(80px, 1fr));
    grid-template-rows: repeat(4, auto);
  }
}

@media (max-width: 600px) {
  .date-grid-new {
    grid-template-columns: repeat(3, minmax(75px, 1fr));
    grid-template-rows: repeat(5, auto);
    gap: 0.5rem;
  }

  .slider-arrow-btn {
    width: 2rem;
    height: 2rem;
    background-size: 16px;
  }

  .date-grid-btn {
    font-size: 0.8rem;
    padding: 0.5rem 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NewPatientScheduling/styles/DateSliderBar.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,oDAAoD;EACpD,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;EACjF,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;;EAElB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;;EAEnB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;;EAErB,UAAU,EAAE,gCAAgC;EAC5C,sBAAsB;;EAEtB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,yDAA0L;AAC5L;;AAEA;EACE,yDAA2L;AAC7L;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,mDAAmD;IACnD,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,mDAAmD;IACnD,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF","sourcesContent":["/* === Wrapper Around Entire Component === */\n.date-slider-row-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin: 1.5rem 0;\n  padding: 1rem;\n  border-radius: var(--radius);\n  background-color: var(--clr-white);\n  box-shadow: var(--shadow-1);\n}\n\n/* === Grid Container for 14 Dates in 2 Rows === */\n.date-grid-new {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(100px, 1fr));\n  grid-template-rows: repeat(2, auto);\n  gap: 0.75rem;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n/* === Individual Date Button === */\n.date-grid-btn {\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  border-radius: 8px;\n  border: 1px solid var(--clr-primary-4);\n  background-color: var(--clr-grey-5);\n  color: var(--clr-white);\n  cursor: pointer;\n  font-weight: 500;\n  text-align: center;\n  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: var(--shadow-xs);\n  white-space: nowrap;\n}\n\n.date-grid-btn:hover {\n  background-color: var(--clr-primary-1);\n  border-color: var(--clr-primary-6);\n  transform: translateY(-1px);\n}\n\n.date-grid-btn.selected {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  border-color: var(--clr-primary-6);\n  box-shadow: var(--shadow-1);\n}\n\n/* === Arrow Buttons (Prev/Next) === */\n.slider-arrow-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: var(--clr-white);\n  border: 1px solid var(--clr-primary-5);\n  border-radius: 50%;\n  \n  width: 2.25rem;\n  height: 2.25rem;\n  min-width: 2.25rem;\n  min-height: 2.25rem;\n\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 18px;\n\n  padding: 0; /* Ensures icon stays centered */\n  box-sizing: border-box;\n\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.slider-arrow-btn:hover {\n  transform: scale(1.05);\n}\n\n\n.slider-arrow-btn.left {\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='gray' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 7l-5 5 5 5V7z'/%3E%3C/svg%3E\");\n}\n\n.slider-arrow-btn.right {\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='gray' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 17l5-5-5-5v10z'/%3E%3C/svg%3E\");\n}\n\n.slider-arrow-btn:hover {\n  background-color: var(--clr-primary-10);\n}\n\n.slider-arrow-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* === Loading Spinner === */\n.loading-spinner_v3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem 0;\n  text-align: center;\n  color: var(--clr-grey-6);\n  font-size: 1rem;\n  position: relative;\n}\n\n.loading-spinner_v3::before {\n  content: \"\";\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.75rem;\n  border: 3px solid var(--clr-grey-5);\n  border-top-color: var(--clr-primary-7);\n  border-radius: 50%;\n  animation: spinLoader 0.8s linear infinite;\n}\n\n@keyframes spinLoader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* === Responsive Tweaks === */\n@media (max-width: 1024px) {\n  .date-grid-new {\n    grid-template-columns: repeat(4, minmax(80px, 1fr));\n    grid-template-rows: repeat(4, auto);\n  }\n}\n\n@media (max-width: 600px) {\n  .date-grid-new {\n    grid-template-columns: repeat(3, minmax(75px, 1fr));\n    grid-template-rows: repeat(5, auto);\n    gap: 0.5rem;\n  }\n\n  .slider-arrow-btn {\n    width: 2rem;\n    height: 2rem;\n    background-size: 16px;\n  }\n\n  .date-grid-btn {\n    font-size: 0.8rem;\n    padding: 0.5rem 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
